__turbopack_context__.v({
  "column": "productAbbrevation-module-scss-module__WPRXta__column",
  "correctionBtn": "productAbbrevation-module-scss-module__WPRXta__correctionBtn",
  "date": "productAbbrevation-module-scss-module__WPRXta__date",
  "datesCol": "productAbbrevation-module-scss-module__WPRXta__datesCol",
  "dealsListTable": "productAbbrevation-module-scss-module__WPRXta__dealsListTable",
  "expandCollapseBtn": "productAbbrevation-module-scss-module__WPRXta__expandCollapseBtn",
  "icon": "productAbbrevation-module-scss-module__WPRXta__icon",
  "link": "productAbbrevation-module-scss-module__WPRXta__link",
  "parentCell": "productAbbrevation-module-scss-module__WPRXta__parentCell",
  "productCol": "productAbbrevation-module-scss-module__WPRXta__productCol",
  "region": "productAbbrevation-module-scss-module__WPRXta__region",
  "regionCol": "productAbbrevation-module-scss-module__WPRXta__regionCol",
  "sponsorCol": "productAbbrevation-module-scss-module__WPRXta__sponsorCol",
  "tickerCol": "productAbbrevation-module-scss-module__WPRXta__tickerCol",
  "tickerLabel": "productAbbrevation-module-scss-module__WPRXta__tickerLabel",
  "verified": "productAbbrevation-module-scss-module__WPRXta__verified",
});
